/* One Testorise selection per cart. Unrelated products are preserved. */
(() => {
  let pending;
  const base = window.Shopify?.routes?.root || '/';
  const trackSelection = async item => {
    // Klaviyo receives purchase context only, never quiz answers or the current URL.
    // A blocked/slow analytics script must never prevent a purchase.
    if (!window.klaviyo?.track) return;
    if (window.Shopify?.customerPrivacy?.marketingAllowed?.() === false) return;
    const plan = Number(item.selling_plan_allocation?.selling_plan?.id || 0);
    const checkout = new URL('https://testorise.com/products/testorise');
    checkout.search = new URLSearchParams({view:'checkout', variant:String(item.variant_id), selling_plan:String(plan), quantity:String(item.quantity)}).toString();
    let timer;
    try {
      await Promise.race([
        Promise.resolve(window.klaviyo.track('Testorise Cart Ready', {
          VariantID: item.variant_id, Quantity: item.quantity, SellingPlanID: plan,
          ProductName: 'Testorise', CheckoutURL: checkout.href,
          LaunchQA: false,
        })),
        new Promise(resolve => { timer = setTimeout(resolve, 800); }),
      ]);
    } catch (_) { /* Checkout remains available when tracking fails. */ }
    finally { clearTimeout(timer); }
  };
  const request = async (path, body) => {
    const response = await fetch(base + path, {method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: {'Accept':'application/json', ...(body ? {'Content-Type':'application/json'} : {})}, ...(body ? {body:JSON.stringify(body)} : {})});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Could not update your selection. Please try again.');
    return data;
  };
  window.TestoriseCart = {
    select(form, variantIds) {
      if (pending) return pending;
      const work = async () => {
        const data = new FormData(form);
        const id = Number(data.get('id'));
        const plan = Number(data.get('selling_plan') || 0);
        const quantity = Number(data.get('quantity') ?? 1);
        const ids = variantIds.map(Number);
        if (!id || !ids.includes(id)) throw new Error('Please choose a supply option.');
        if (!Number.isInteger(quantity) || quantity < 1 || quantity > 100) throw new Error('Please choose a valid quantity.');
        trackSelection({variant_id:id, quantity, ...(plan ? {selling_plan_allocation:{selling_plan:{id:plan}}} : {})});
        const cart = await request('cart.js');
        const matches = item => Number(item.variant_id) === id && Number(item.selling_plan_allocation?.selling_plan?.id || 0) === plan;
        let selected = cart.items.find(matches);
        const adding = !selected;
        if (adding) {
          const added = await request('cart/add.js', {items:[{id, quantity, ...(plan ? {selling_plan:plan} : {})}]});
          selected = (added.items || []).find(matches);
        }
        if (!selected) throw new Error('Your selection was not added. Please try again.');
        const ours = item => item.product_id === selected.product_id || ids.includes(Number(item.variant_id));
        const others = cart.items.filter(item => item.key !== selected.key && ours(item));
        let line = selected;
        if (adding || others.length || selected.quantity !== quantity) {
          const updates = {[selected.key]: quantity};
          others.forEach(item => { updates[item.key] = 0; });
          const verified = await request('cart/update.js', {updates});
          const items = verified.items.filter(ours);
          if (items.length !== 1 || !matches(items[0]) || items[0].quantity !== quantity) throw new Error('Please review your cart before checking out.');
          line = items[0];
        }
        return line;
      };
      const run = () => work();
      pending = (navigator.locks ? navigator.locks.request('testorise-cart-selection', run) : run()).finally(() => {pending = null;});
      return pending;
    },
    error(form, message) {
      let alert = form.querySelector('[data-cart-error]');
      if (!alert) { alert = document.createElement('p'); alert.dataset.cartError = ''; alert.setAttribute('role','alert'); alert.style.cssText='padding:12px;background:#fff;color:#101924;border:2px solid #315b88;border-radius:6px'; form.append(alert); }
      alert.textContent = message;
    }
  };
})();
